var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
export var MUSIC_VOLUME = 0.5;
var MusicPlayer = /** @class */ (function () {
    function MusicPlayer() {
        var _this = this;
        this.listeners = [];
        this.audio = document.createElement("audio");
        this.currentTrack = "";
        this.targetPlaying = false;
        this.audio.crossOrigin = "use-credentials";
        this.audio.addEventListener("loadedmetadata", function () {
            _this.triggerListeners();
        });
        this.audio.addEventListener("ended", function () {
            _this.targetPlaying = false;
            _this.triggerListeners();
        });
    }
    MusicPlayer.prototype.triggerListeners = function () {
        var e_1, _a;
        var state = this.getState();
        try {
            for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                var e = _c.value;
                e(state);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    MusicPlayer.prototype.addStateChangeListener = function (l) {
        this.listeners.push(l);
    };
    MusicPlayer.prototype.removeStateChangeListener = function (l) {
        this.listeners.splice(this.listeners.indexOf(l), 1);
    };
    MusicPlayer.prototype.getState = function () {
        return {
            playing: this.targetPlaying,
            track: this.currentTrack,
            duration: this.audio.duration,
            time: this.audio.currentTime,
        };
    };
    MusicPlayer.prototype.pause = function () {
        this.audio.pause();
        this.targetPlaying = false;
        this.triggerListeners();
    };
    MusicPlayer.prototype.play = function () {
        var _this = this;
        this.targetPlaying = true;
        this.triggerListeners();
        this.audio.play().then(function () {
            _this.targetPlaying = true;
        }, function () {
            _this.targetPlaying = false;
        });
    };
    MusicPlayer.prototype.load = function (url) {
        var _this = this;
        this.audio.src = url;
        this.currentTrack = url;
        if (this.targetPlaying) {
            this.audio.play().then(function () {
                _this.targetPlaying = true;
            }, function () {
                _this.targetPlaying = false;
            });
        }
        this.triggerListeners();
    };
    MusicPlayer.prototype.seek = function (time) {
        this.audio.currentTime = time;
        this.triggerListeners();
    };
    MusicPlayer.prototype.dispose = function () {
        this.audio.pause();
    };
    MusicPlayer.prototype.setVolume = function (volume) {
        this.audio.volume = volume * MUSIC_VOLUME;
    };
    return MusicPlayer;
}());
export { MusicPlayer };
export function useAudioPlayerState(player) {
    var _a = __read(useState(function () { return player.getState(); }), 2), state = _a[0], setState = _a[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setState(player.getState());
        }, 1000);
        player.addStateChangeListener(setState);
        return function () {
            clearInterval(interval);
            player.removeStateChangeListener(setState);
        };
    }, [player]);
    return state;
}
